import React from 'react';
import { Button } from '@kl/components-v6';
import { ButtonProps } from '@kl/components-v6/src/button/types';
import { Locale, LocaleProps } from 'shared/ui/locale';

export interface LocalizedButtonProps extends ButtonProps, Pick<LocaleProps, 'params'> {
    localizationKey: string;
    color?: string;
}

export const LocalizedButton: React.FC<LocalizedButtonProps> = ({
    localizationKey,
    params = [],
    mode = 'primary',
    color,
    ...buttonProps
}) => (
    <Button mode={mode} {...buttonProps} style={{ ...(color && { backgroundColor: color }) }}>
        <Locale localizationKey={localizationKey} params={params} />
    </Button>
);
